import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const t = o((c, s) => /* @__PURE__ */ l.jsx(
  i,
  {
    ref: s,
    ...c,
    image: (a) => /* @__PURE__ */ l.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 85,
        height: 102,
        fill: "none",
        viewBox: "0 0 85 102",
        ...a,
        children: [
          /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "#1D1D44",
              d: "M77.969 61.9c1.51 1.82 2.84 4.47 2 7.55-1.07 3.92-5.01 4.99-7.56 4.98 1.28-3.32 2.44-6.91 3.45-10.65-.11.08-.2.17-.31.24 0 0-.09-1.54-.3-3.89-1.5 6.22-3.43 12.13-5.65 17.19-4.93 11.21-13.47 19.56-22.82 22.35-2.33.69-6.26.69-8.58 0-9.36-2.78-17.89-11.14-22.83-22.35-2.21-5.06-4.14-10.96-5.64-17.16-.21 2.33-.3 3.86-.3 3.86-.11-.08-.21-.17-.32-.25 1.01 3.74 2.17 7.34 3.45 10.66-2.56 0-6.48-1.06-7.56-4.98-.84-3.08.48-5.74 2-7.56-.35-.37-.68-.75-1.01-1.15-1.84 2.11-3.48 5.29-2.44 9.1 1.3 4.75 5.98 6.07 9.03 6.07.2 0 .38-.01.56-.02.28.69.56 1.36.85 2.02 5.11 11.61 14 20.27 23.77 23.18 1.3.39 3.01.58 4.72.58s3.42-.19 4.72-.58c9.77-2.91 18.66-11.57 23.73-23.1l-.49-.32.53.23c.29-.66.57-1.34.85-2.02.18.01.36.02.56.02 3.05 0 7.73-1.32 9.03-6.07 1.04-3.81-.6-6.99-2.44-9.1-.32.4-.66.78-1.01 1.15z"
            }
          ),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "#F2F2F2",
              d: "M69.889 37.79c.23.31.46.63.68.95-.22-.36-.44-.67-.68-.95"
            }
          ),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "#1D1D44",
              d: "M42.489 87.22c1.22 0 2.43-.46 3.36-1.39l2.28-2.28-.99-.99-2.28 2.28a3.356 3.356 0 0 1-4.73 0l-2.28-2.28-.99.99 2.28 2.28c.93.93 2.14 1.39 3.36 1.39zM35.749 91.2l-.55 1.29c.2.08 3.34 1.4 7.53 1.4 2.16 0 4.6-.35 7.05-1.4l-.55-1.29c-6.64 2.84-13.4.03-13.47 0zM34.769 61.75l.81-1.26c-3.16-2.04-13.56-4.76-18.18-1.42l.88 1.21c3.81-2.76 13.22-.65 16.48 1.46zM22.149 65.22l-.8 1.16s3.13 2.11 7.19 2.11c2.05 0 4.35-.53 6.63-2.11l-.8-1.16c-6.02 4.17-11.97.17-12.23 0zM49.389 60.49l.81 1.26c3.26-2.11 12.67-4.22 16.48-1.46l.88-1.21c-4.61-3.34-15.02-.63-18.18 1.42zM50.599 65.22l-.8 1.16c2.29 1.58 4.59 2.11 6.63 2.11 4.07 0 7.14-2.08 7.19-2.11l-.8-1.16c-.25.17-6.21 4.17-12.23 0z"
            }
          ),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "#1D1D44",
              d: "M9.109 63.77c.11.08.21.17.32.25 0 0 .08-1.53.3-3.86.04-.43.08-.88.13-1.37-.5.66-.94 1.46-1.16 2.3-.32-1.82.42-4.79 1.39-7.2-1.5 1.33-1.71 1.46-2 2.44 0-.82.9-4.34 3.01-8.23l-1.46.46s1.47-5.06 4.88-9.97c.17-.25.36-.5.54-.75.04-.05.07-.1.11-.15v.02c.33-.38.67-.68 1.03-.88 2.15 3.81 7.03 8.63 17.95 8.63 3.23 0 7-.43 11.37-1.42 2.82-.15 5.13-.52 7.05-1.01-1.96-.16-4.07-.7-6.54-1.7 7.07.78 10.04.1 16.79-3.75.31-.18.63-.36.96-.55a.2.2 0 0 0 .06-.04h.02c1.16-.55 2.42-.78 4.17-.43.64.13 1.22.55 1.76 1.17v-.02s.05.08.08.12c.23.28.46.59.68.95 3.33 4.87 4.77 9.81 4.77 9.81l-1.46-.46c2.11 3.89 3.01 7.41 3.01 8.23-.3-.98-.5-1.1-2-2.44.97 2.41 1.72 5.39 1.39 7.2-.22-.83-.65-1.63-1.15-2.29.05.47.09.91.13 1.33.21 2.35.3 3.89.3 3.89.11-.08.21-.16.31-.24.75-.56 1.46-1.19 2.11-1.88.35-.37.68-.75 1.01-1.15 8.38-10.33 7.49-30.83.24-41.59-6.16-9.13-16.7-19.13-36.73-19.14-20.03.01-30.57 10-36.73 19.14-7.26 10.76-8.14 31.26.23 41.59.32.4.66.78 1.01 1.15.65.68 1.35 1.31 2.1 1.87zm30.72-19.74c-13.74 1.82-19.76-2.98-22.36-7.04 3.87 3.83 8.97 5.85 15.5 6.15 1.89.44 4.14.76 6.86.89m-7.43-1.92c-7.03-.45-12.29-3.03-16.03-7.87 7.49 4.36 12.31 6.51 16.03 7.87"
            }
          )
        ]
      }
    )
  }
));
t.displayName = "HairLossMale1Icon";
export {
  t as HairLossMale1Icon,
  t as default
};
//# sourceMappingURL=index.js.map
